export default __webpack_public_path__ + "static/media/kitchen5-beforeA-2048w.b9d5198f.webp";